import React, { useContext } from 'react';

import {AuthConsumer} from '../../Context/AuthContext';

export default function SignUp(props) {
    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [signupComplete, setSignupComplete] = React.useState(false);

    if (signupComplete) {
        return (
            <div>Thank you for registering</div>
        )
    }

    const registerUser = () => {
        setSignupComplete(true);
    }
    
    console.log('props in signup component', props);

    return (
        <AuthConsumer>
            {({ signUp }) => {

                const doSignUp = () => {
                    signUp(username, password);
                    registerUser();
                }
                
                return (
                    <div>
                        <input placeholder="username" onChange={setUsername} value={username} />
                        <input placeholder="password" onChange={setPassword} value={password} />
                        <button onClick={doSignUp}>Register</button>
                    </div>
                )
            }}
        </AuthConsumer>
    )
}